export default __webpack_public_path__ + "static/media/Background-Portal.1b5f5a95.jpg";